var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.77717 15.0853C6.18576 15.5409 6.71029 15.7912 7.25455 15.7912H7.25533C7.80196 15.7912 8.32886 15.5409 8.73823 15.0846C8.95751 14.8422 9.33139 14.8224 9.57355 15.0411C9.81649 15.2598 9.83621 15.6349 9.61772 15.8773C8.98039 16.5855 8.14192 16.9756 7.25533 16.9756H7.25376C6.36954 16.9748 5.53265 16.5847 4.89769 15.8765C4.67919 15.6341 4.69891 15.2591 4.94186 15.0411C5.1848 14.8216 5.55868 14.8414 5.77717 15.0853ZM7.29383 0C10.7999 0 13.1552 2.73346 13.1552 5.28611C13.1552 6.59915 13.4889 7.15579 13.843 7.74638C14.1932 8.32908 14.59 8.99073 14.59 10.2414C14.3147 13.4367 10.9821 13.6973 7.29383 13.6973C3.60551 13.6973 0.272148 13.4367 1.04405e-05 10.2919C-0.00234535 8.99073 0.394409 8.32908 0.744625 7.74638L0.868261 7.53806C1.17267 7.01435 1.43244 6.44467 1.43244 5.28611C1.43244 2.73346 3.78772 0 7.29383 0ZM7.29383 1.18434C4.53706 1.18434 2.6156 3.34616 2.6156 5.28611C2.6156 6.92761 2.16048 7.68637 1.7582 8.35592C1.43559 8.89361 1.18082 9.3184 1.18082 10.2414C1.31254 11.7305 2.29457 12.513 7.29383 12.513C12.2655 12.513 13.2783 11.6958 13.4092 10.1901C13.4068 9.3184 13.1521 8.89361 12.8295 8.35592C12.4272 7.68637 11.9721 6.92761 11.9721 5.28611C11.9721 3.34616 10.0506 1.18434 7.29383 1.18434Z",
    fill: "#1D3557"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.17d4db5f654ce5e5e63c800a8b8a28d5.svg";
export { ForwardRef as ReactComponent };